import { css } from '@emotion/react';
import { ReactElement, useCallback } from 'react';

import { styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';

const MAX_TEXT_LENGTH = 80;

const styles = css`
	cursor: pointer;
	outline: none;
	overflow-wrap: normal;
	word-break: break-word;
	width: auto;
	span {
		display: flex;
	}
	.ncc-polygon {
		width: 40px;
		height: 40px;
	}
	.ncc-top-left {
		shape-outside: polygon(0px 0px, 100% 0%, 0px 100%);
		float: left;
		clip-path: polygon(0px 0px, 100% 0%, 0px 100%);
	}

	.ncc-top-right {
		shape-outside: polygon(100% 0px, 100% 100%, 0 0);
		float: right;
		clip-path: polygon(100% 0px, 100% 100%, 0 0);
	}
`;

type Interface = { className: string; onClick: VoidFunction; value: string };

const Component = ({ onClick, className, value }: Interface): ReactElement => {
	const countWords = useCallback((): number => {
		const newValue = value.replace(/[\s]+/gim, ' ');
		const result = newValue.split(' ').length;
		return result;
	}, [value]);

	const showIndent = value.length > MAX_TEXT_LENGTH && countWords() > 1;
	return (
		<button className={className} onClick={onClick}>
			{showIndent && <div className="ncc-polygon ncc-top-left" />}
			{showIndent && <div className="ncc-polygon ncc-top-right" />}
			<span>
				{value}
				{showIndent && <div />}
			</span>
		</button>
	);
};

export const Button = styled(Component)(
	({
		theme: {
			chat: {
				buttons: { selectionButton },
			},
		},
	}: {
		disabled: boolean;
		theme: Theme;
	}) => selectionButton,
	styles
);
